import styled from 'styled-components';
import { cssVars } from '../../shared/lib/styledTheme';

export const TemplatesContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background-color: ${cssVars.bgColor};
  overflow-y: auto;
`;

export const TemplatesHeader = styled.div`
  padding: 24px;
  border-bottom: 1px solid ${cssVars.borderColor};
  background-color: ${cssVars.bgSecondary};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TemplatesTitle = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin: 0;
`;

export const AddButton = styled.button`
  padding: 10px 20px;
  background-color: ${cssVars.primary};
  color: ${cssVars.white};
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${cssVars.primaryHover};
  }
`;

export const TemplatesContent = styled.div`
  padding: 24px;
`;

export const Section = styled.div`
  margin-bottom: 32px;
`;

export const SectionTitle = styled.h2`
  font-size: 20px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin-bottom: 16px;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px;
`;

export const EmptyStateText = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: ${cssVars.textPrimary};
  margin-bottom: 8px;
`;

export const EmptyStateSubtext = styled.div`
  font-size: 14px;
  color: ${cssVars.textSecondary};
`;

export const TemplatesList = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
`;

export const TemplateCard = styled.div`
  background-color: ${cssVars.bgSecondary};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 8px;
  padding: 16px;
`;

export const TemplateCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

export const TemplateCardName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  flex: 1;
`;

export const TemplateCardCategory = styled.div`
  padding: 4px 8px;
  background-color: ${cssVars.bgTertiary};
  border-radius: 4px;
  font-size: 12px;
  color: ${cssVars.textSecondary};
`;

export const TemplateCardContent = styled.div`
  font-size: 14px;
  color: ${cssVars.textSecondary};
  line-height: 1.5;
  margin-bottom: 12px;
`;

export const TemplateCardActions = styled.div`
  display: flex;
  gap: 8px;
`;

export const EditButton = styled.button`
  padding: 6px 12px;
  background-color: ${cssVars.bgColor};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 4px;
  color: ${cssVars.textPrimary};
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${cssVars.hover};
  }
`;

export const DeleteButton = styled.button`
  padding: 6px 12px;
  background-color: ${cssVars.bgColor};
  border: 1px solid ${cssVars.error};
  border-radius: 4px;
  color: ${cssVars.error};
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${cssVars.error};
    color: ${cssVars.white};
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background-color: ${cssVars.bgColor};
  border-radius: 8px;
  width: 90%;
  max-width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

export const ModalHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid ${cssVars.borderColor};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: ${cssVars.textPrimary};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: ${cssVars.textSecondary};
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${cssVars.hover};
  }
`;

export const ModalBody = styled.div`
  padding: 24px;
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: ${cssVars.textPrimary};
  margin-bottom: 8px;
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  background-color: ${cssVars.bgSecondary};
  color: ${cssVars.textPrimary};
  font-size: 14px;
  font-family: inherit;
  outline: none;

  &:focus {
    border-color: ${cssVars.primary};
  }
`;

export const FormTextarea = styled.textarea`
  width: 100%;
  min-height: 200px;
  padding: 10px 12px;
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  background-color: ${cssVars.bgSecondary};
  color: ${cssVars.textPrimary};
  font-size: 14px;
  font-family: inherit;
  resize: vertical;
  outline: none;

  &:focus {
    border-color: ${cssVars.primary};
  }
`;

export const ModalFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid ${cssVars.borderColor};
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const CancelButton = styled.button`
  padding: 10px 20px;
  background-color: ${cssVars.bgSecondary};
  color: ${cssVars.textPrimary};
  border: 1px solid ${cssVars.borderColor};
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${cssVars.hover};
  }
`;

export const SaveButton = styled.button`
  padding: 10px 20px;
  background-color: ${cssVars.primary};
  color: ${cssVars.white};
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${cssVars.primaryHover};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

